import { Reveal } from "./Reveal";

const STEPS = [
  {
    n: "01",
    t: "Данные рождения",
    d: "Вы отправляете дату, место и точное время рождения. Точное время рождения важно для корректного построения карты.",
  },
  {
    n: "02",
    t: "Индивидуальный анализ",
    d: "Я изучаю Вашу карту и в течение до двух недель готовлю персональный аудиоразбор.",
  },
  {
    n: "03",
    t: "Вы слушаете",
    d: "Вы получаете аудиоразбор и можете прослушать его в удобном для Вас темпе, возвращаясь к нему снова.",
  },
  {
    n: "04",
    t: "Онлайн-встреча",
    d: "После прослушивания мы планируем онлайн-созвон. На встрече я отвечаю на Ваши вопросы и помогаю связать полученную информацию с реальными жизненными ситуациями.",
  },
];

export const HowItWorks = () => (
  <section id="process" data-testid="process-section" className="mx-auto max-w-[1240px] px-6 py-28 md:px-10 md:py-40">
    <Reveal>
      <span className="font-serif text-7xl italic text-sand md:text-8xl">03</span>
      <h2 className="mt-6 max-w-2xl font-serif text-[1.8rem] leading-tight tracking-tight text-charcoal md:text-[3rem]">
        Как проходит консультация
      </h2>
    </Reveal>

    <div className="mt-20 border-t border-charcoal/15">
      {STEPS.map((s, i) => (
        <Reveal key={s.n} delay={i * 0.05}>
          <div className="grid grid-cols-1 gap-4 border-b border-charcoal/15 py-10 md:grid-cols-[auto_0.9fr_1.4fr] md:items-baseline md:gap-12">
            <span className="font-serif text-5xl italic text-sage md:text-6xl">{s.n}</span>
            <h3 className="font-serif text-2xl tracking-tight text-charcoal md:text-[1.8rem]">{s.t}</h3>
            <p className="max-w-lg font-sans text-base font-light leading-relaxed text-charcoal/70">
              {s.d}
            </p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

const INCLUDED = [
  "индивидуальный анализ карты",
  "персональный аудиоразбор",
  "онлайн-встреча после прослушивания",
  "ответы на вопросы и обсуждение практического применения",
];

export const Offer = () => (
  <section id="reading" data-testid="offer-section" className="mx-auto max-w-[1240px] px-6 pb-28 md:px-10 md:pb-40">
    <Reveal>
      <div className="bg-beige px-7 py-14 md:px-20 md:py-24">
        <div className="grid gap-12 md:grid-cols-[1.1fr_0.9fr] md:gap-20">
          <div>
            <p className="font-sans text-xs uppercase tracking-[0.32em] text-sage">
              Формат работы
            </p>
            <h2 className="mt-6 font-serif text-4xl leading-tight tracking-tight text-charcoal md:text-5xl">
              Индивидуальное чтение Human Design
            </h2>
            <p className="mt-8 max-w-md font-sans text-base font-light leading-relaxed text-charcoal/75">
              Персональный разбор Вашей карты в формате аудиозаписи + онлайн-встреча
              для вопросов и интеграции материала.
            </p>

            <div className="mt-10 flex items-baseline gap-3">
              <span data-testid="offer-price" className="font-serif text-5xl tracking-tight text-charcoal md:text-6xl">
                250
              </span>
              <span className="font-sans text-lg text-charcoal/60">USD</span>
            </div>

            <a
              href="#booking"
              data-testid="offer-cta"
              className="mt-10 inline-block bg-charcoal px-9 py-4 font-sans text-sm text-ivory transition-colors duration-300 hover:bg-sage"
            >
              Записаться на чтение
            </a>
          </div>

          <div className="md:border-l md:border-charcoal/15 md:pl-16">
            <p className="font-sans text-sm uppercase tracking-[0.2em] text-charcoal/60">
              В стоимость входит:
            </p>
            <ul className="mt-7 space-y-5">
              {INCLUDED.map((item) => (
                <li key={item} className="flex items-start gap-4 border-b border-charcoal/10 pb-5">
                  <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-sand" />
                  <span className="font-sans text-base font-light leading-relaxed text-charcoal/80">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Reveal>
  </section>
);
